<template>
    <section>
        <ul>
            <folderItem v-for="f in favourites" :key="f.id"
                        :folder="f" :folderName="f.name" folderType="F"
                        :showExpander="false" :selectedType="selectedType" :selectedFolder="selectedFolder"
                        @select="$emit('select', $event)">
            </folderItem>
        </ul>
    </section>
</template>

<script>
import FolderItem from '@/components/folderItem';

export default {
  name: 'folderFavourites',
  components: { FolderItem },
  props: {
    favouriteFolders: Array,
    selectedType: String,
    selectedFolder: Number
  },
  computed: {
    favourites() {
      return this.favouriteFolders.map(f => this.$store.getters.getFolderByName(f)).filter(f => f);
    }
  }
};
</script>

<style scoped>
    ul {
        padding-left: 5px;
        list-style: none;
        margin-block-end: 0;
    }
</style>
